module.exports = __webpack_public_path__ + "media/fonts/icomoon-611a259e.svg";